<template lang="pug">
  .business-documents.custom-container
    .section-title Documentos
    b-breadcrumb.breadcrumb
      b-breadcrumb-item(:to="{name:'Home'}") Inicio
      b-breadcrumb-item(:to="{name:'BusinessDocuments'}") Documentos
      b-breadcrumb-item(:to="{name:'BusinessFolders'}" ) {{ businessName }}
    .table-view
      ListBusinessDocuments(@businessName="businessName=$event")
</template>

<script>
import ListBusinessDocuments from '../components/business_documents/ListBusinessDocuments'
export default {
  data(){
    return{
      businessName:'',
      folderName:''
    }
  },
  components: {
    ListBusinessDocuments
  }
}
</script>
